module.exports = __webpack_public_path__ + "static/img/member_icon.0a45dec3.png";